module.exports = __webpack_public_path__ + "static/media/rewards-cashback.510532a8.svg";